import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-dlg-tips',
    templateUrl: './dlg-tips.component.pug',
    styleUrls: ['./dlg-tips.component.less']
})
export class DlgTipsComponent {

    constructor(
        public dialogRef: MatDialogRef<DlgTipsComponent>,

        @Inject(MAT_DIALOG_DATA) public data: any
    ) {
    }

    onContinue() {
        this.dialogRef.close(true);
    }

    onCancel() {
        this.dialogRef.close(false);
    }

    onClose() {
        this.dialogRef.close();
    }
}
